import { configureStore } from "@reduxjs/toolkit";
import { api } from "./api/apiSlice";

// One reducer/middleware pair instead of doh_web_frontend's 14 — see
// apiSlice.ts for why (14 slices existed only because of two hardcoded,
// inconsistent backend hosts, not because the domains needed isolation).
export function makeStore() {
  return configureStore({
    reducer: { [api.reducerPath]: api.reducer },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
  });
}

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
